/**
 * A hash router, deliberately about thirty lines.
 *
 * There are five destinations in this app and no server rendering, so a routing
 * library would spend the entry-chunk budget (60 KB gzip, and the Catch screen
 * lives in it) on machinery for problems this product does not have.
 *
 * Hash routing rather than history routing: an installed PWA launched from a
 * home-screen slot has no server round trip to configure, and a hash never
 * 404s if the app is ever served from a subpath.
 */

export const ROUTES = ['catch', 'today', 'onboard'] as const;
export type Route = (typeof ROUTES)[number];

const DEFAULT_ROUTE: Route = 'catch';

function parse(hash: string): Route {
  const name = hash.replace(/^#\/?/, '').split('/')[0] ?? '';
  return (ROUTES as readonly string[]).includes(name) ? (name as Route) : DEFAULT_ROUTE;
}

export function currentRoute(): Route {
  return parse(globalThis.location?.hash ?? '');
}

export function navigate(route: Route): void {
  globalThis.location.hash = route === DEFAULT_ROUTE ? '#/' : `#/${route}`;
}

export function onRouteChange(handler: (route: Route) => void): () => void {
  const listener = () => handler(currentRoute());
  addEventListener('hashchange', listener);
  return () => removeEventListener('hashchange', listener);
}
